import { render, staticRenderFns } from "./BlogDetails_v2.vue?vue&type=template&id=02a621ac&"
import script from "./BlogDetails_v2.vue?vue&type=script&lang=js&"
export * from "./BlogDetails_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports